<div class="py-2 pb-md-1 checkbox" [class.form-check-inline]="inline">
  <label
    class="form-check-label ms-1"
    [attr.for]="'checkbox-' + index"
    [id]="'label-' + index"
  >
    <input
      #checkboxInput
      [checked]="isChecked()"
      (change)="checkboxValueChanged($event, checkedValue)"
      class="form-check-input"
      type="checkbox"
      tabindex="-1"
      [id]="'checkbox-' + index"
      [name]="name | globalTranslate"
      [attr.aria-labelledby]="'label-' + index"
      [formControl]="control"
      nh-value
      [checkedValue]="checkedValue"
      [uncheckedValue]="uncheckedValue"
      [attr.disabled]="isDisabled"
    />
    <span
      class="cr"
      tabindex="0"
      (keydown.enter)="checkboxInput.click()"
      (keydown.space)="checkboxInput.click(); $event.preventDefault()"
      ><i class="cr-icon fa fa-check" aria-hidden="true"></i
    ></span>
    @if (mandatory) {
    <span class="text-danger">*</span>
    }
    {{ label | globalTranslate }}
    <ng-content select="[checkbox-label]"></ng-content>
  </label>
  <ng-content></ng-content>
</div>
